import { apiFetch } from "./api";

export function getSystems() {
  return apiFetch<string[]>(`/api/manifest/supported-systems`);
}